import { useMemo } from "react";

import { getInvoiceTypeDisplayNameById, invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";

export const useInvoiceTypeSelectOptions = () => {
		return useMemo(()=>{
			return [
				{ value: invoiceTypeId.RegularInvoice, label: getInvoiceTypeDisplayNameById(invoiceTypeId.RegularInvoice) },
				{ value: invoiceTypeId.SelfBilledInvoice, label: getInvoiceTypeDisplayNameById(invoiceTypeId.SelfBilledInvoice) },
			]
		}, []);
}